import React, { useRef, useEffect, useState, useMemo, useContext } from "react";
import Typed from "typed.js";
import { AnimatePresence, motion } from "framer-motion/dist/framer-motion";
import { headingVariant, containerVariant, itemVariant } from "./PageVariants";
import { NavContext } from "./App";
import { InView } from "react-intersection-observer";

export default function About({ pageRef }) {
	const typedElementForSub = useRef(null);
	const typedElementForHeading = useRef(null);
	const setSelectedNav = useContext(NavContext);
	const [isInView, setIsInView] = useState(false);
	const [scentence, setScentence] = useState(0);
	const scentenceList = useMemo(
		() => [
			"Senior Full Stack Software Engineer",
			"React Js Developer",
			"C# Programmer",
			".Net Developer",
		],
		[]
	);

	React.useEffect(() => {
		setTimeout(() => {
			if (scentence !== scentenceList.length - 1) {
				setScentence(scentence + 1);
			} else {
				setScentence(0);
			}
		}, 2000);
	}, [scentenceList, scentence]);

	useEffect(() => {
		let typedSub = new Typed(typedElementForSub.current, {
			strings: ["A LITTLE INFO"],
			startDelay: 0,
			typeSpeed: 40,
			showCursor: false,
		});

		let typedHeading = new Typed(typedElementForHeading.current, {
			strings: ["ABOUT ME"],
			startDelay: 800,
			typeSpeed: 80,
			showCursor: false,
		});

		return () => {
			typedSub.destroy();
			typedHeading.destroy();
		};
	}, [isInView]);

	const aboutVariants = {
		enter: {
			y: -10,
			opacity: 0,
		},
		center: {
			y: 0,
			opacity: 1,
		},
		exit: {
			y: 10,
			opacity: 0,
		},
	};

	const viewChange = (inView) => {
		setIsInView(inView);
		if (inView) {
			setSelectedNav({ Heading: "ABOUT" });
		}
	};

	return (
		<InView threshold={0.1} onChange={(inView, entry) => viewChange(inView)}>
			<div
				ref={pageRef}
				className="w-full md:w-10/12 m-auto grid grid-cols-1 justify-start items-start"
			>
				<motion.h4
					variants={headingVariant}
					initial="hide"
					animate={isInView ? "show" : "hide"}
					exit="hide"
					className="text-3xl text-green-600 border-l-8 border-green-600 pl-4 pt-6 h-24 tracking-wider"
				>
					<span
						className="text-gray-600 dark:text-gray-400 text-sm"
						ref={typedElementForSub}
					></span>
					<br />
					<span className="text-green-600" ref={typedElementForHeading}></span>
				</motion.h4>

				<motion.div
					variants={containerVariant}
					initial="hide"
					animate="show"
					className="text-gray-500 bg-white p-3 md:p-4 lg:p-10 my-8 rounded-3xl text-lg space-y-3 font-semibold dark:text-gray-200 dark:bg-gray-600"
				>
					<motion.div variants={itemVariant}>
						I'm a
						<span className="inline-flex justify-start items-center">
							<AnimatePresence exitBeforeEnter>
								<motion.span
									style={{ minWidth: "90px" }}
									className="text-green-500 inline mx-2"
									key={scentence}
									variants={aboutVariants}
									initial="enter"
									animate="center"
									exit="exit"
									transition={{
										duartion: 2,
									}}
								>
									{scentenceList[scentence]}
								</motion.span>
							</AnimatePresence>
						</span>
						with 6+ years of coding experience, which has given me a strong
						foundation for web development and building complex solutions. I was
						graduated from University of Bridgeport with a Masters degree in
						Computer Science in 2015 and currently working for Metlife Group,
						Inc. I am passionate about coding and solving problems through my
						code, and I am excited to work alongside other amazing programmers
						and learn so much more!
					</motion.div>
				</motion.div>
			</div>
		</InView>
	);
}
